import Vue from 'vue'
import NuxtLoading from '~/components/layout/loading'

import '../node_modules/@sf/lib/src/themes/common/global/main.scss'

import '../node_modules/@sf/lib/src/themes/alpha/styleguide.scss'

import '../node_modules/@sf/lib/src/themes/alpha/main.scss'

import '../assets/global.scss'

import _77068119 from './admin.layout.f4400550.vue'
import _77180f1e from '../layouts/blank.vue'
import _6f6c098b from '../layouts/default.vue'

const layouts = { "_admin": _77068119,"_blank": _77180f1e,"_default": _6f6c098b }

export default {
  head: {"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"icon","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"icon","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F","crossorigin":true},{"rel":"stylesheet","type":"text\u002Fcss","href":"\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Montserrat:400,500,600,700,900&amp;subset=cyrillic-ext"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.c1deaa04.json"}],"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"hid":"description","name":"description","content":"Bir neçə dəqiqə ərzində 500 AZN-dək sürətli və rahat onlayn kredit. Zaminsiz və girovsuz, tək şəxsiyyət vəsiqəsi ilə pulunuzu bank kartınıza əldə edin."},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Manato.az"},{"hid":"theme-color","name":"theme-color","content":"#ffffff"},{"hid":"og:type","name":"og:type","property":"og:type","content":"website"},{"hid":"og:title","name":"og:title","property":"og:title","content":"Manato.az"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"Manato.az"},{"hid":"og:description","name":"og:description","property":"og:description","content":"Bir neçə dəqiqə ərzində 500 AZN-dək sürətli və rahat onlayn kredit. Zaminsiz və girovsuz, tək şəxsiyyət vəsiqəsi ilə pulunuzu bank kartınıza əldə edin."},{"hid":"og:url","name":"og:url","property":"og:url","content":"https:\u002F\u002Fwww.manato.az"}],"style":[],"script":[{"src":"\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id=GTM-NWCTGBF&l=dataLayer","async":true}],"titleTemplate":"%s | Manato.az","title":"Sürətli və rahat onlayn kredit","htmlAttrs":{"lang":"az"}},

  render(h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })
    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [ layoutEl ])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter(el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [ templateEl ])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [loadingEl, transitionEl])
  },
  data: () => ({
    isOnline: true,
    layout: null,
    layoutName: ''
  }),
  beforeCreate() {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created() {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this
    // add to window so we can listen when ready
    if (process.client) {
      window.$nuxt = this
      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
  },

  mounted() {
    this.$loading = this.$refs.loading
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline() {
      return !this.isOnline
    }
  },
  methods: {
    refreshOnlineStatus() {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    errorChanged() {
      if (this.nuxt.err && this.$loading) {
        if (this.$loading.fail) this.$loading.fail()
        if (this.$loading.finish) this.$loading.finish()
      }
    },

    setLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      this.layout = layouts['_' + layout]
      return this.layout
    },
    loadLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      return Promise.resolve(layouts['_' + layout])
    }
  },
  components: {
    NuxtLoading
  }
}
